module.exports = __webpack_public_path__ + "assets/images/office-contact-imagef4472968.jpg";